/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/BRj9eonsORJ7GIUdm8gnu5
 */
export const schema = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "properties": {
        "backgroundColor": {
            "type": "array",
            "items": {
                "type": "string",
                "pattern": "^(transparent|[a-fA-F0-9]{6})$"
            },
            "default": [
                "ffe082",
                "90caf9",
                "80deea",
                "ffab91",
                "b39ddb",
                "a5d6a7",
                "9fa8da",
                "81d4fa",
                "c5e1a5",
                "e6ee9c",
                "ffcc80",
                "f48fb1",
                "ce93d8",
                "ef9a9a",
                "80cbc4"
            ]
        },
        "icon": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "alarm",
                    "archive",
                    "award",
                    "bag",
                    "bandaid",
                    "bank",
                    "basket",
                    "basket2",
                    "basket3",
                    "bell",
                    "bicycle",
                    "binoculars",
                    "book",
                    "bookshelf",
                    "boombox",
                    "boxSeam",
                    "box",
                    "boxes",
                    "bricks",
                    "briefcase",
                    "brightnessHigh",
                    "brush",
                    "bucket",
                    "bug",
                    "building",
                    "calculator",
                    "cameraReels",
                    "camera",
                    "cart2",
                    "cashCoin",
                    "clock",
                    "cloudDrizzle",
                    "cloudMoon",
                    "cloudSnow",
                    "cloud",
                    "clouds",
                    "coin",
                    "compass",
                    "controller",
                    "cupStraw",
                    "cup",
                    "dice5",
                    "disc",
                    "display",
                    "doorClosed",
                    "doorOpen",
                    "dpad",
                    "droplet",
                    "easel",
                    "eggFried",
                    "egg",
                    "emojiHeartEyes",
                    "emojiLaughing",
                    "emojiSmileUpsideDown",
                    "emojiSmile",
                    "emojiSunglasses",
                    "emojiWink",
                    "envelope",
                    "eyeglasses",
                    "flag",
                    "flower1",
                    "flower2",
                    "flower3",
                    "gem",
                    "gift",
                    "globe",
                    "globe2",
                    "handThumbsUp",
                    "handbag",
                    "hdd",
                    "heart",
                    "hourglassSplit",
                    "hourglass",
                    "houseDoor",
                    "house",
                    "inbox",
                    "inboxes",
                    "key",
                    "keyboard",
                    "ladder",
                    "lamp",
                    "laptop",
                    "lightbulb",
                    "lightningCharge",
                    "lightning",
                    "lock",
                    "magic",
                    "mailbox",
                    "map",
                    "megaphone",
                    "minecartLoaded",
                    "minecart",
                    "moonStars",
                    "moon",
                    "mortarboard",
                    "mouse",
                    "mouse2",
                    "newspaper",
                    "paintBucket",
                    "palette",
                    "palette2",
                    "paperclip",
                    "pen",
                    "pencil",
                    "phone",
                    "piggyBank",
                    "pinAngle",
                    "plug",
                    "printer",
                    "projector",
                    "puzzle",
                    "router",
                    "scissors",
                    "sdCard",
                    "search",
                    "send",
                    "shopWindow",
                    "shop",
                    "signpost2",
                    "signpostSplit",
                    "signpost",
                    "smartwatch",
                    "snow",
                    "snow2",
                    "snow3",
                    "speaker",
                    "star",
                    "stoplights",
                    "stopwatch",
                    "sun",
                    "tablet",
                    "thermometer",
                    "ticketPerforated",
                    "tornado",
                    "trash",
                    "trash2",
                    "tree",
                    "trophy",
                    "truckFlatbed",
                    "truck",
                    "tsunami",
                    "umbrella",
                    "wallet",
                    "wallet2",
                    "watch",
                    "webcam"
                ]
            },
            "default": [
                "alarm",
                "archive",
                "award",
                "bag",
                "bandaid",
                "bank",
                "basket",
                "basket2",
                "basket3",
                "bell",
                "bicycle",
                "binoculars",
                "book",
                "bookshelf",
                "boombox",
                "boxSeam",
                "box",
                "boxes",
                "bricks",
                "briefcase",
                "brightnessHigh",
                "brush",
                "bucket",
                "bug",
                "building",
                "calculator",
                "cameraReels",
                "camera",
                "cart2",
                "cashCoin",
                "clock",
                "cloudDrizzle",
                "cloudMoon",
                "cloudSnow",
                "cloud",
                "clouds",
                "coin",
                "compass",
                "controller",
                "cupStraw",
                "cup",
                "dice5",
                "disc",
                "display",
                "doorClosed",
                "doorOpen",
                "dpad",
                "droplet",
                "easel",
                "eggFried",
                "egg",
                "emojiHeartEyes",
                "emojiLaughing",
                "emojiSmileUpsideDown",
                "emojiSmile",
                "emojiSunglasses",
                "emojiWink",
                "envelope",
                "eyeglasses",
                "flag",
                "flower1",
                "flower2",
                "flower3",
                "gem",
                "gift",
                "globe",
                "globe2",
                "handThumbsUp",
                "handbag",
                "hdd",
                "heart",
                "hourglassSplit",
                "hourglass",
                "houseDoor",
                "house",
                "inbox",
                "inboxes",
                "key",
                "keyboard",
                "ladder",
                "lamp",
                "laptop",
                "lightbulb",
                "lightningCharge",
                "lightning",
                "lock",
                "magic",
                "mailbox",
                "map",
                "megaphone",
                "minecartLoaded",
                "minecart",
                "moonStars",
                "moon",
                "mortarboard",
                "mouse",
                "mouse2",
                "newspaper",
                "paintBucket",
                "palette",
                "palette2",
                "paperclip",
                "pen",
                "pencil",
                "phone",
                "piggyBank",
                "pinAngle",
                "plug",
                "printer",
                "projector",
                "puzzle",
                "router",
                "scissors",
                "sdCard",
                "search",
                "send",
                "shopWindow",
                "shop",
                "signpost2",
                "signpostSplit",
                "signpost",
                "smartwatch",
                "snow",
                "snow2",
                "snow3",
                "speaker",
                "star",
                "stoplights",
                "stopwatch",
                "sun",
                "tablet",
                "thermometer",
                "ticketPerforated",
                "tornado",
                "trash",
                "trash2",
                "tree",
                "trophy",
                "truckFlatbed",
                "truck",
                "tsunami",
                "umbrella",
                "wallet",
                "wallet2",
                "watch",
                "webcam"
            ]
        }
    }
};
